import comp from "./GradeScale";
export default comp;
